const defaultLocale = 'en';

function locale() {
    return localStorage.locale || defaultLocale;
}

export {
    locale,
    defaultLocale
};